
import Vue from "vue";
import { CrmSheduleCalendarOptions } from "@/utils/crm/crm-shedule-calendar-options";
import AppCrmSelectContact from "./CrmSelectContact.vue";
import AppCrmEditProperties from "./CrmEditProperties.vue";
import AppEditContact from "@/components/contacts/ContactEdit.vue";
import Crm from "@/models/crm/crm";
import { Contact } from "@/models/base";
import { getContactServiceByGroupId } from "@/utils/services/contact-services";
import { copyToClipboard } from "@/utils/clipboard";

export default Vue.extend({

	data(){
		return {
			editModal: false,
			editContact: new Contact(),
			loadingEdit: false
		};
	},
	props: {
		crm: {
			type: Object as ()=>Crm,
			required: true
		},
		lg: {
			type: [Number, String]
		},
		md: {
			type: [Number, String]
		}
	},
	methods: {
		clearContact() {
			this.crm.Contact = new Contact();
			this.crm.ContactID = 0;
		},
		async openEditContact() {
			if (!this.crm.ContactID || !this.crm.Contact) return;
			this.loadingEdit = true;
			try {
				let service = getContactServiceByGroupId(this.crm.Contact.GroupID);
				this.editContact = await service.getContact(this.crm.ContactID);
				this.editModal = true;
			} finally {
				this.loadingEdit = false;
			}
		},
		onContactSaved() {
			this.crm.Contact = this.editContact;
			this.crm.ContactID = this.editContact.ID;
			this.editModal = false;
		},
		save(options?:CrmSheduleCalendarOptions){
			this.$emit("save", options);
		},
		triggerPhone(value:string){
			this.$emit("trigger-phone", value);
		},
		copyEmail(value:string){
			if (!value) return;
			copyToClipboard(value);
			this.$wf.notify(this.$ct("email-copied"), "success", 3000, "check");
		}
	},
	components: {
		AppCrmSelectContact,
		AppCrmEditProperties,
		AppEditContact,
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});

